import React, { useEffect } from 'react'
import styled from 'styled-components'
import AOS from 'aos';

function Hero() {
  useEffect(() => {
    AOS.init({
      duration: 1200,  // Global duration of animations in milliseconds
    });
  }, []);

  return (
    <Container>
      <video src='./video.mp4' 
      autoPlay
      muted 
      loop
       />
      <VideoOverlay />
      <Wrap>
        <h1 className='shine text-focus-in' data-aos="zoom-in">IBEX FILMZ</h1>
        <h3 data-aos="zoom-in" className='text-focus-in'>"Bringing Your Ideas to Life Through Motion"</h3>
        <p data-aos="zoom-in" className='text-focus-in'>  Corporate | Resort Productions | Real Estate  | Documentaries | Destination Promotions | Action Sports | Product Commercials | Aerial Cinematography</p>
      </Wrap>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  height: 80vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const VideoOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 100%, rgba(0,0,0,0) 100%);
  z-index: 1;
`;

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 2;

  @media only screen and (max-width: 1200px) {
    padding: 10px;
  }

  h1 {
    font-size: 120px;
    font-weight: 600;

    @media only screen and (max-width: 1200px) {
      font-size: 55px;
    }

    @media only screen and (max-width: 1024px) {
      font-size: 75px;  /* Larger font for tablet */
    }

    @media only screen and (max-width: 768px) {
      font-size: 50px;  /* Adjust font for mobile */
    }
  }

  p {
    font-size: 20px;
    color: var(--secondary-text-color);
    width: 62%;
    text-align: center;

    @media only screen and (max-width: 1200px) {
      font-size: 15px;
      text-align: center;
    }

    @media only screen and (max-width: 1024px) {
      font-size: 18px;  /* Adjust font for tablet */
    }

    @media only screen and (max-width: 768px) {
      font-size: 14px;  /* Smaller font for mobile */
    }
  }

  h3 {
    letter-spacing: 1.1px;
    font-size: 32px;
    margin: 10px 0;
    color: var(--secondary-text-color);
    font-family: "Cambay", sans-serif;
    font-weight: 550;

    @media only screen and (max-width: 1200px) {
      font-size: 20px;
      text-align: center;
    }

    @media only screen and (max-width: 1024px) {
      font-size: 28px;  /* Adjust font for tablet */
    }

    @media only screen and (max-width: 768px) {
      font-size: 18px;  /* Smaller font for mobile */
    }
  }

  img {
    width: 30%;

    @media only screen and (max-width: 1200px) {
      width: 80%;
    } 

    @media only screen and (max-width: 1024px) {
      width: 50%;  /* Adjust size for tablet */
    }
  }
`;

export default Hero;
